import { useState } from "react";
import { Share2, Loader2 } from "lucide-react";
import { toast } from "sonner";

function roundRect(ctx, x, y, w, h, r) {
  ctx.beginPath();
  ctx.moveTo(x + r, y);
  ctx.arcTo(x + w, y, x + w, y + h, r);
  ctx.arcTo(x + w, y + h, x, y + h, r);
  ctx.arcTo(x, y + h, x, y, r);
  ctx.arcTo(x, y, x + w, y, r);
  ctx.closePath();
}

async function composeCard({ stat, title, sub, color }) {
  const canvas = document.createElement("canvas");
  canvas.width = 1080;
  canvas.height = 1080;
  const ctx = canvas.getContext("2d");

  ctx.fillStyle = color;
  ctx.fillRect(0, 0, 1080, 1080);
  ctx.fillStyle = "rgba(0,0,0,0.06)";
  for (let x = 40; x < 1080; x += 90) {
    for (let y = 40; y < 1080; y += 90) {
      ctx.beginPath();
      ctx.arc(x, y, 5, 0, Math.PI * 2);
      ctx.fill();
    }
  }

  ctx.fillStyle = "#000";
  roundRect(ctx, 116, 176, 880, 740, 48);
  ctx.fill();
  ctx.fillStyle = "#fff";
  roundRect(ctx, 100, 160, 880, 740, 48);
  ctx.fill();
  ctx.lineWidth = 8;
  ctx.strokeStyle = "#000";
  roundRect(ctx, 100, 160, 880, 740, 48);
  ctx.stroke();

  const img = new Image();
  img.src = "/mascot.png";
  await img.decode();
  const mx = 540, my = 330, mr = 130;
  ctx.save();
  ctx.beginPath();
  ctx.arc(mx, my, mr, 0, Math.PI * 2);
  ctx.clip();
  ctx.drawImage(img, mx - mr, my - mr, mr * 2, mr * 2);
  ctx.restore();
  ctx.lineWidth = 8;
  ctx.beginPath();
  ctx.arc(mx, my, mr, 0, Math.PI * 2);
  ctx.stroke();

  ctx.textAlign = "center";
  ctx.fillStyle = "#0A0A0A";
  ctx.font = "600 120px 'Fredoka', sans-serif";
  ctx.fillText(stat, 540, 620);
  ctx.font = "600 52px 'Fredoka', sans-serif";
  ctx.fillText(title, 540, 700);
  ctx.fillStyle = "#555";
  ctx.font = "500 34px 'Outfit', sans-serif";
  ctx.fillText(sub, 540, 760);

  ctx.fillStyle = "#000";
  roundRect(ctx, 340, 810, 400, 64, 32);
  ctx.fill();
  ctx.fillStyle = "#FFE066";
  ctx.font = "600 32px 'Fredoka', sans-serif";
  ctx.fillText("\u2726 StudySpark", 540, 853);

  return canvas;
}

export const ShareWinCard = ({ stat, title, sub, color = "#FFE066", testId = "share-win-button", className = "" }) => {
  const [busy, setBusy] = useState(false);

  const share = async () => {
    setBusy(true);
    try {
      const canvas = await composeCard({ stat, title, sub, color });
      const blob = await new Promise((res) => canvas.toBlob(res, "image/png"));
      const file = new File([blob], "studyspark-win.png", { type: "image/png" });
      if (navigator.canShare && navigator.canShare({ files: [file] })) {
        await navigator.share({ files: [file], title: "My StudySpark win" });
      } else {
        const a = document.createElement("a");
        a.href = URL.createObjectURL(blob);
        a.download = "studyspark-win.png";
        a.click();
        URL.revokeObjectURL(a.href);
        toast.success("Win card saved — post it anywhere!");
      }
    } catch (e) {
      if (e?.name !== "AbortError") toast.error("Couldn't create the share card.");
    }
    setBusy(false);
  };

  return (
    <button
      onClick={share}
      disabled={busy}
      data-testid={testId}
      className={`bg-[#F2C6DE] border-2 border-black rounded-full shadow-[4px_4px_0px_rgba(0,0,0,1)] active:shadow-none active:translate-y-1 transition-all font-bold px-6 py-3 inline-flex items-center justify-center gap-2 disabled:opacity-60 ${className}`}
    >
      {busy ? <Loader2 size={18} className="animate-spin" /> : <Share2 size={18} />} Share this win
    </button>
  );
};
